import React from 'react';

import { SEO } from 'main/components';
import {
  FutureProof,
  Landing,
  Optimized,
  OrqaIntegration,
  Visualisation,
  CTA,
} from 'modules/rapidFire';
export const RapidFire = () => {
  return (
    <>
      <SEO seoTitle="rapidFIRE - 5.8GHz Receiver Module for FPV Goggles - Orqa" />
      <section className="rapid-fire-section">
        <Landing />
        <Visualisation />
        <FutureProof />
        <Optimized />
        <OrqaIntegration />
        <CTA />
      </section>
    </>
  );
};
